<template>
    <div class="maintenance-container">
        <!-- Дорога на фоне -->
        <div class="road">
            <div class="road-line"></div>
        </div>

        <!-- Плавающие иконки автотематики -->
        <div class="floating-elements">
            <div class="floating-icon" v-for="n in 5" :key="n" :style="getFloatingStyle(n)">
                <v-icon :color="getIconColor(n)" size="28">{{ getIcon(n) }}</v-icon>
            </div>
        </div>

        <div class="maintenance-content">
            <!-- Машинка на домкрате -->
            <div class="car-scene">
                <div class="jack">
                    <div class="jack-base"></div>
                    <div class="jack-arm"></div>
                </div>
                <div class="car-body">
                    <v-icon class="car-main-icon">mdi-car-side</v-icon>
                    <!-- Колесо открученное рядом -->
                    <div class="loose-wheel">
                        <v-icon class="wheel-icon">mdi-tire</v-icon>
                    </div>
                    <!-- Гаечный ключ -->
                    <div class="wrench">
                        <v-icon class="wrench-icon">mdi-wrench</v-icon>
                    </div>
                </div>
            </div>

            <!-- Текст -->
            <h1 class="maintenance-title">{{ $t('maintenance_page.title') }}</h1>
            <p class="maintenance-description">{{ $t('maintenance_page.description') }}</p>

            <!-- Обратный отсчёт -->
            <div class="retry-section">
                <div class="retry-countdown">
                    <v-icon color="#FF6B35" class="mr-2 refresh-spin">mdi-refresh</v-icon>
                    <span>{{ $t('maintenance_page.retry_in', { seconds: countdown }) }}</span>
                </div>
                <v-progress-linear
                    :value="progressValue"
                    color="#FF6B35"
                    background-color="rgba(255,107,53,0.15)"
                    rounded
                    height="6"
                    class="mt-3"
                    style="max-width: 300px; margin: 0 auto;"
                ></v-progress-linear>
            </div>

            <!-- Кнопка -->
            <div class="maintenance-actions mt-6">
                <v-btn
                    large
                    color="#FF6B35"
                    dark
                    rounded
                    elevation="2"
                    :loading="checking"
                    @click="checkNow"
                    class="action-button"
                >
                    <v-icon left>mdi-car-wrench</v-icon>
                    {{ $t('maintenance_page.check_now') }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'MaintenancePage',
    data() {
        return {
            countdown: 30,
            checking: false,
            timer: null,
        };
    },
    computed: {
        progressValue() {
            return ((30 - this.countdown) / 30) * 100;
        },
    },
    mounted() {
        this.startTimer();
    },
    beforeDestroy() {
        this.stopTimer();
    },
    methods: {
        startTimer() {
            this.countdown = 30;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.checkAvailability();
                }
            }, 1000);
        },
        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        async checkAvailability() {
            this.stopTimer();
            this.checking = true;
            try {
                const apiUrl = this.$store.getters.getApiUrl || axios.defaults.baseURL || '';
                await axios.get(`${apiUrl}/up`);
                this.$store.commit('setMaintenanceMode', false);
            } catch (e) {
                this.countdown = 30;
                this.startTimer();
            } finally {
                this.checking = false;
            }
        },
        checkNow() {
            this.checkAvailability();
        },
        getFloatingStyle(index) {
            const positions = [
                { top: '8%', left: '8%', animationDelay: '0s', animationDuration: '5s' },
                { top: '15%', right: '12%', animationDelay: '1.2s', animationDuration: '4s' },
                { top: '65%', left: '6%', animationDelay: '0.6s', animationDuration: '6s' },
                { top: '75%', right: '8%', animationDelay: '2s', animationDuration: '4.5s' },
                { top: '40%', right: '5%', animationDelay: '1.5s', animationDuration: '5.5s' },
            ];
            return positions[index - 1];
        },
        getIcon(index) {
            const icons = ['mdi-key-variant', 'mdi-gas-station', 'mdi-steering', 'mdi-speedometer', 'mdi-traffic-cone'];
            return icons[index - 1];
        },
        getIconColor(index) {
            const colors = ['#FFB347', '#FF6B35', '#FFD700', '#FF8C42', '#FFA07A'];
            return colors[index - 1];
        },
    },
};
</script>

<style scoped>
.maintenance-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
    overflow: hidden;
    padding: 20px;
}

/* Дорога */
.road {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: #2d2d2d;
    z-index: 1;
}

.road-line {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 4px;
    background: repeating-linear-gradient(
        90deg,
        #FFD700,
        #FFD700 40px,
        transparent 40px,
        transparent 80px
    );
    animation: road-move 2s linear infinite;
}

@keyframes road-move {
    from { transform: translateX(0); }
    to { transform: translateX(-80px); }
}

/* Плавающие иконки */
.floating-elements {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 1;
}

.floating-icon {
    position: absolute;
    animation: float 4s ease-in-out infinite;
    opacity: 0.25;
}

@keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    25% { transform: translateY(-15px) rotate(5deg); }
    75% { transform: translateY(10px) rotate(-3deg); }
}

/* Карточка */
.maintenance-content {
    position: relative;
    z-index: 2;
    text-align: center;
    background: rgba(255, 255, 255, 0.97);
    padding: 50px 40px 40px;
    border-radius: 24px;
    box-shadow:
        0 20px 60px rgba(0, 0, 0, 0.4),
        0 0 0 1px rgba(255, 255, 255, 0.1);
    max-width: 520px;
    width: 100%;
}

/* Сцена с машинкой */
.car-scene {
    position: relative;
    height: 120px;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.car-body {
    position: relative;
    animation: car-tilt 3s ease-in-out infinite;
    transform-origin: right bottom;
}

@keyframes car-tilt {
    0%, 100% { transform: rotate(-3deg); }
    50% { transform: rotate(-5deg); }
}

.car-main-icon {
    font-size: 100px !important;
    color: #FF6B35 !important;
    filter: drop-shadow(2px 4px 6px rgba(0,0,0,0.15));
}

/* Домкрат */
.jack {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 0;
    z-index: 1;
}

.jack-base {
    width: 30px;
    height: 8px;
    background: #555;
    border-radius: 2px;
}

.jack-arm {
    width: 6px;
    height: 30px;
    background: linear-gradient(to top, #555, #888);
    margin: 0 auto;
    border-radius: 2px;
    animation: jack-pump 2s ease-in-out infinite;
}

@keyframes jack-pump {
    0%, 100% { height: 30px; }
    50% { height: 35px; }
}

/* Открученное колесо */
.loose-wheel {
    position: absolute;
    right: -35px;
    bottom: -5px;
    animation: wheel-wobble 2s ease-in-out infinite;
}

.wheel-icon {
    font-size: 36px !important;
    color: #333 !important;
}

@keyframes wheel-wobble {
    0%, 100% { transform: rotate(0deg) translateY(0); }
    25% { transform: rotate(15deg) translateY(-3px); }
    75% { transform: rotate(-10deg) translateY(2px); }
}

/* Гаечный ключ */
.wrench {
    position: absolute;
    left: -25px;
    bottom: 5px;
    animation: wrench-turn 1.5s ease-in-out infinite;
    transform-origin: bottom right;
}

.wrench-icon {
    font-size: 28px !important;
    color: #888 !important;
}

@keyframes wrench-turn {
    0%, 100% { transform: rotate(0deg); }
    30% { transform: rotate(-25deg); }
    60% { transform: rotate(5deg); }
}

/* Текст */
.maintenance-title {
    font-size: 32px;
    font-weight: 800;
    color: #1a1a2e;
    margin-bottom: 12px;
    animation: fadeInUp 0.8s ease-out;
}

.maintenance-description {
    font-size: 16px;
    color: #64748b;
    margin-bottom: 28px;
    line-height: 1.6;
    animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Retry */
.retry-section {
    animation: fadeInUp 1.2s ease-out;
    color: #64748b;
    font-size: 15px;
}

.retry-countdown {
    display: flex;
    align-items: center;
    justify-content: center;
}

.refresh-spin {
    animation: spin 2s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Кнопка */
.maintenance-actions {
    animation: fadeInUp 1.4s ease-out;
}

.action-button {
    transition: all 0.3s ease !important;
    letter-spacing: 0.5px;
    font-weight: 600;
}

.action-button:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 10px 30px rgba(255, 107, 53, 0.4) !important;
}

/* Планшеты */
@media (max-width: 768px) {
    .maintenance-content {
        padding: 40px 28px 32px;
        border-radius: 20px;
    }

    .maintenance-title {
        font-size: 26px;
    }

    .maintenance-description {
        font-size: 15px;
    }

    .car-main-icon {
        font-size: 80px !important;
    }

    .car-scene {
        height: 100px;
    }

    .floating-icon {
        display: none;
    }
}

/* Мобильные */
@media (max-width: 480px) {
    .maintenance-container {
        padding: 15px;
    }

    .maintenance-content {
        padding: 30px 20px 24px;
        border-radius: 16px;
    }

    .maintenance-title {
        font-size: 22px;
        margin-bottom: 10px;
    }

    .maintenance-description {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .car-main-icon {
        font-size: 65px !important;
    }

    .car-scene {
        height: 80px;
        margin-bottom: 15px;
    }

    .wheel-icon {
        font-size: 28px !important;
    }

    .wrench-icon {
        font-size: 22px !important;
    }

    .road {
        height: 50px;
    }
}

/* Темная тема */
.theme--dark .maintenance-content {
    background: rgba(30, 30, 44, 0.97);
}

.theme--dark .maintenance-title {
    color: #f1f5f9;
}

.theme--dark .maintenance-description {
    color: #94a3b8;
}

.theme--dark .retry-section {
    color: #94a3b8;
}

.theme--dark .jack-base,
.theme--dark .jack-arm {
    background: #888;
}
</style>
